import { render } from "./wechatUser.vue?vue&type=template&id=53257439"
import script from "./wechatUser.vue?vue&type=script&lang=js"
export * from "./wechatUser.vue?vue&type=script&lang=js"

import exportComponent from "D:\\xyzw\\springboot-vue-demo\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__